import { AplicacaoMonitoramento } from './../aplicacao-monitoramento.model';
import { AplicacaoMonitoramentoDetalhado } from './../aplicacao-monitoramento-detalhado.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-aplicacao-monitoramento-visualizador',
  templateUrl: './aplicacao-monitoramento-visualizador.component.html',
  styleUrls: ['./aplicacao-monitoramento-visualizador.component.css'],
})
export class AplicacaoMonitoramentoVisualizadorComponent<E extends AplicacaoMonitoramento> implements OnInit {
  @Input()
  public aplicacao: AplicacaoMonitoramentoDetalhado<E>;

  public mostrarDados = false;

  ngOnInit(): void {}
}
